import React from 'react';
import Header from '../components/Header';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header title="Privacy Policy" />
      
      <div className="container mx-auto px-4 py-8">
        <div className="bg-white rounded-xl p-6 shadow-sm">
          <h1 className="text-2xl font-semibold text-gray-900 mb-6">
            Privacy Policy
          </h1>

          <div className="space-y-6 text-gray-600">
            <div>
              <h2 className="text-xl font-medium text-gray-800 mb-3">Introduction</h2>
              <p className="leading-relaxed">
                At minto, we take your privacy seriously. This Privacy Policy explains how we collect, 
                use, disclose, and safeguard your information when you use our mobile repair services 
                or visit our website. Please read this privacy policy carefully. If you do not agree 
                with the terms of this privacy policy, please do not access our services.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-medium text-gray-800 mb-3">Information We Collect</h2>
              <div className="space-y-3">
                <p>We collect information that you provide directly to us, including:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Name and contact information</li>
                  <li>Address for doorstep service</li>
                  <li>Device information (make, model, issues)</li>
                  <li>Service history</li>
                  <li>Payment information</li>
                </ul>
              </div>
            </div>

            <div>
              <h2 className="text-xl font-medium text-gray-800 mb-3">How We Use Your Information</h2>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>To provide and maintain our service</li>
                <li>To notify you about changes to our service</li>
                <li>To provide customer support</li>
                <li>To process payments</li>
                <li>To send service updates and promotional materials</li>
                <li>To improve our service</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-medium text-gray-800 mb-3">Data Security</h2>
              <p className="leading-relaxed">
                We implement appropriate technical and organizational security measures to protect 
                your personal information. However, please note that no method of transmission over 
                the internet or electronic storage is 100% secure.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-medium text-gray-800 mb-3">Data Sharing and Disclosure</h2>
              <p className="leading-relaxed">
                We do not sell, trade, or rent your personal information to third parties. We may 
                share your information with service providers who assist us in operating our website, 
                conducting our business, or servicing you.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-medium text-gray-800 mb-3">Your Rights</h2>
              <p className="leading-relaxed mb-3">
                You have the right to:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Access your personal information</li>
                <li>Correct inaccurate information</li>
                <li>Request deletion of your information</li>
                <li>Object to processing of your information</li>
                <li>Withdraw consent</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-medium text-gray-800 mb-3">Contact Us</h2>
              <p className="leading-relaxed">
                If you have any questions about this Privacy Policy, please contact us:
              </p>
              <div className="mt-4 space-y-2">
                <div className="flex items-center gap-2">
                  <i className="fas fa-phone text-minto-500 w-5"></i>
                  <a href="tel:+919324299258" className="text-minto-600 hover:text-minto-700">
                    +91 93242 99258
                  </a>
                </div>
                <div className="flex items-center gap-2">
                  <i className="fab fa-whatsapp text-green-500 w-5"></i>
                  <a 
                    href="https://wa.me/+919324299258" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-green-600 hover:text-green-700"
                  >
                    WhatsApp Support
                  </a>
                </div>
              </div>
            </div>

            <div className="text-sm text-gray-500 pt-6 border-t border-gray-200">
              <p>Last updated: {new Date().toLocaleDateString()}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage; 